import { AppAreaConfig } from '@/funnels/@types'
import chairWorkoutsMale from '../yoga/activity-male-chair-workouts'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-chair-tai-chi-fwf',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-chair-tai-chi-m', 'age-chair-tai-chi-m'],
		route: {
			path: '/chair-tai-chi-m',
			name: 'male-chair-tai-chi-funnel',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-chair-fwf',
		route: {
			path: '/chair-tai-chi-m/ob/:page(.*)?',
			name: 'activity-male-chair-tai-chi-fwf',
		},
		slug: 'activity-male-chair-tai-chi-fwf',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: chairWorkoutsMale,
				page: 'focus-area',
			},
		},
	},
}

export default appAreaConfig
